import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MediaImage } from "@/components/Media";
import { api } from "@/lib/api";

export default function Library() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => {
    Promise.all([api.get("/content/videos"), api.get("/content/photos")])
      .then(([v, p]) => setItems([...v.data.items, ...p.data.items].filter((i) => !i.locked)))
      .catch(() => setItems([]));
  }, []);
  return (
    <div data-testid="library-screen" className="px-5 pt-6 pb-6">
      <h1 className="text-2xl font-extrabold">My Library</h1>
      <p className="text-sm text-[#a7a0af]">Everything your memberships and purchases unlock.</p>
      {items === null && <p className="mt-4 text-sm text-[#a7a0af]">Loading…</p>}
      {items?.length === 0 && <p data-testid="library-empty" className="mt-4 text-sm text-[#a7a0af]">Nothing unlocked yet. Subscribe to a creator or PEEPING ALL ACCESS to build your library.</p>}
      <div className="mt-4 grid grid-cols-2 gap-3">
        {items?.map((it) => (
          <button key={it.id} data-testid={`library-item-${it.id}`} onClick={() => navigate(it.type === "video" ? "/app/videos" : "/app/photos")} className="relative aspect-[3/4] overflow-hidden rounded-2xl border border-[#6a00ff]/25 text-left">
            <MediaImage url={it.cover_url} className="h-full w-full object-cover" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 to-transparent p-2">
              <p className="truncate text-xs font-semibold">{it.title}</p>
              <p className="text-[0.6rem] text-[#a7a0af]">{it.creator?.display_name} · {it.type === "video" ? "Video" : "Album"}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
